import React from "react";
import { Grid, TextField, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
    title: {
        marginBottom: theme.spacing(2),
    },
}));

const CampaignNameStep = ({ campaign, onChange }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography variant="h6" className={classes.title}>
                Informações Básicas
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Nome da Campanha"
                        variant="outlined"
                        value={campaign.name || ""}
                        onChange={(e) => onChange("name", e.target.value)}
                        required
                        autoFocus
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Início da Janela de Envio"
                        type="time"
                        variant="outlined"
                        value={campaign.sendWindowStart || "08:00"}
                        onChange={(e) => onChange("sendWindowStart", e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            step: 300, // 5 min
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Fim da Janela de Envio"
                        type="time"
                        variant="outlined"
                        value={campaign.sendWindowEnd || "18:00"}
                        onChange={(e) => onChange("sendWindowEnd", e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            step: 300, // 5 min
                        }}
                    />
                </Grid>
            </Grid>
            <Typography variant="caption" color="textSecondary" style={{ marginTop: 10, display: 'block' }}>
                * A campanha só enviará e-mails dentro deste intervalo de horário.
            </Typography>
        </div>
    );
};

export default CampaignNameStep;
